<template>
  <div class="termsAgreement">
    <!-- <div class="thirdPartyLogin">
      <img
        src="../../assets/img/registrationLogin/wx_logo.png"
        alt="微信登录"
        class="wx_logo thirdParty"
      >
      <img
        src="../../assets/img/registrationLogin/qq_logo.png"
        alt="QQ登录"
        class="qq_logo thirdParty"
      >
      <img
        src="../../assets/img/registrationLogin/wb_logo.png"
        alt="微博登录"
        class="wb_logo thirdParty"
      >
    </div> -->
    <div class="termsAgrDesc" :class="{ yuntuColor: yuntuColor }">
      <div @click="change">
        <img
          v-show="!checked"
          src="../../assets/img/registrationLogin/login-check.png"
          alt=""
          srcset=""
        />
        <img
          v-show="checked"
          :src="yuntuColor?yuntuCheckIcon:qihangCheckIcon"
          alt=""
          srcset=""
        />
      </div>
      我已阅读并同意
      <!-- <router-link :to="xieyiUrl">用户协议</router-link> -->
      <a :href="xieyiUrl">用户协议</a>
      和
      <a :href="yinsiUrl">隐私政策</a>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    yuntuColor: {
      title: Boolean,
      default: false,
    },
  },
  components: {},
  data() {
    return {
      yuntuCheckIcon: 'https://iqh-zt-pord-cdn.iqihang.com/yt-words-mini/mine/login-checked.png',
      qihangCheckIcon: require('../../assets/img/registrationLogin/login-checked.png'),
      xieyiUrl: this.yuntuColor?'https://mobile.iqihang.com/zt/agreement_yt/index.html':'https://mobile.iqihang.com/ark/registeredapp',
      yinsiUrl: this.yuntuColor?'https://mobile.iqihang.com/zt/privacy_yt/index.html':'https://mobile.iqihang.com/zt/privacy_app/index.html',
      checked: false,
    };
  },
  methods: {
    change() {
      this.checked = !this.checked;
      this.$emit('receivePraive', this.checked);
    },
  },
  mounted() {
    this.$emit('receivePraive', this.checked);
  },
};
</script>
<style lang="scss" scoped>
.termsAgreement {
  width: 100%;
  text-align: center;
  // position: fixed;
  // bottom: 152.17px;

  .thirdPartyLogin {
    display: flex;
    padding-bottom: 43px;
    .wx_logo {
      margin-left: 159px;
    }
    .thirdParty {
      width: 91px;
      height: 91px;
      margin-right: 80px;
    }
  }

  .termsAgrDesc {
    display: flex;
    justify-content: center;
    color: #333;
    font-weight: 400;
    font-size: 25px;
    line-height: 36px;
    img {
      width: 32px;
      height: 32px;
      margin: 0 10px 0 0;
    }
    a {
      color: #ff6c02;
      text-decoration: underline;
    }
  }
}

.yuntuColor {
  a {
    color: $yuntuColor !important;
  }
}
</style>
